import React from 'react'

type PhoneNumberInputProps = {
    name: string;
    value: string;
    setValue: (value: string) => void;
    fontSize?: string;
    paddingBlock?: string;
    required?: boolean;
    readOnly?: boolean;
    disabeld?: boolean;
    tabIndex?: number
}

export const PhoneNumberInput = ({
    name,
    value,
    setValue,
    fontSize = "12px",
    paddingBlock,
    required = false,
    readOnly,
    disabeld,
    tabIndex
}: PhoneNumberInputProps) => {
    const onChangePhoneNumber = (inputValue: string) => {
        // Remove non-numeric characters
        const cleanedValue = inputValue?.replace(/\D/g, "");

        if (cleanedValue?.length === 0) {
            setValue("");
            return;
        }

        let formattedNumber = cleanedValue;

        if (cleanedValue?.length > 3 && cleanedValue?.length <= 6) {
            formattedNumber = `(${cleanedValue?.slice(0, 3)}) ${cleanedValue?.slice(3)}`;
        } else if (cleanedValue.length > 6) {
            formattedNumber = `(${cleanedValue?.slice(0, 3)}) ${cleanedValue?.slice(3, 6)}-${cleanedValue?.slice(6, 10)}`;
        }

        setValue(formattedNumber);
    };

    return (
        <input
            type="text"
            tabIndex={tabIndex}
            readOnly={readOnly}
            placeholder="Mobile Number"
            pattern="\(\d{3}\) \d{3}-\d{4}"
            className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
            title="Please enter a 10-digit phone number."
            name={name}
            value={value}
            onChange={(e) => onChangePhoneNumber(e.target.value)}
            required={required}
        />
    );
};

